enum OtherPrograms {
  OnlineFitnessProgram = 'OnlineFitnessProgram',
  SelfGuidedFitnessProgram = 'SelfGuidedFitnessProgram',
  PersonalTrainer = 'PersonalTrainer',
  CalorieCounting = 'CalorieCounting',
  PaidMealPlans = 'PaidMealPlans',
  Keto = 'Keto',
  IntermittentFasting = 'IntermittentFasting',
}


const otherProgramsQuestion = {
  name: 'otherPrograms',
  title: "Have you attempted any of the following in the past?",
  description: 'Select all that apply.',
  type: 'checkbox',
  choices: [
    {
      value: OtherPrograms.OnlineFitnessProgram,
      text: 'Online Fitness Program',
    },
    {
      value: OtherPrograms.SelfGuidedFitnessProgram,
      text: 'Created My Own Program',
    },
    {
      value: OtherPrograms.PersonalTrainer,
      text: 'Personal Trainer',
    },
    {
      value: OtherPrograms.CalorieCounting,
      text: 'Calorie Counting',
    },
    {
      value: OtherPrograms.PaidMealPlans,
      text: 'Paid Meal Plans',
    },
    {
      value: OtherPrograms.Keto,
      text: 'Keto',
    },
    {
      value: OtherPrograms.IntermittentFasting,
      text: 'Intermittent Fasting',
    },
  ],
  showNoneItem: true,
  isRequired: true,
};

export {
  OtherPrograms,
  otherProgramsQuestion,
}